export const EXCLUDED_APP_TYPES = [
  'android',
  'board',
  'external',
  'ios',
  'kiosk',
  'oz',
  'pos',
  'runner',
  'thirdparty',
  'user',
  'xpedite',
  'superadmin for registering devices',
]
